import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import CardBody from '../../shared/components/CardBody';
import Row from '../../shared/components/Row';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { FormText } from '../../shared/components/FormText';
import { FormDropzone } from '../../shared/components/FormDropzone';
import { FormSubmit } from '../../shared/components/FormSubmit';
import { ContractorFileFormValidator } from './ContractorFileFormValidator';
import { ReduxFormUtils } from '../../shared/utils/ReduxFormUtils';
import { connect } from 'react-redux';

const FORM = {
    NAME: 'MyContractorContractorFileForm',
    FIELDS: {
        NAME: 'name',
        FILE: 'file',
        SUBMIT: 'submit',
    },
};

class ContractorFileFormCard extends React.Component {

    dropzone;

    constructor(props) {
        super(props);

        this.state = {
            submitDisabled: true,
        };
    }

    handleSubmitDisabled = (submitDisabled) => {
        this.setState({ submitDisabled });
    };

    handleIsSubmitDisabled = () => {
        const { formValues } = this.props;
        const { submitDisabled } = this.state;
        const noFile = !formValues.file;
        return submitDisabled || noFile;
    };

    render() {
        const {
            onSubmit,
            handleSubmit,
            fileErrorMessage,
        } = this.props;

        return (
            <CardBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Field
                            col={'col-md-6'}
                            name={FORM.FIELDS.NAME}
                            label={I18nUtils.tr('TR_NOMBRE')}
                            placeholder={I18nUtils.tr('TR_INTRODUCE_EL_NOMBRE_DEL_DOCUMENTO')}
                            component={FormText}
                        />
                    </Row>
                    <Row>
                        <Field
                            name={FORM.FIELDS.FILE}
                            component={FormDropzone}
                            maxFiles={1}
                            mimeTypesAccepted={undefined}
                            onSubmitDisabled={this.handleSubmitDisabled}
                            errorMessage={fileErrorMessage}
                        />
                    </Row>
                    <Row>
                        <Field
                            label={I18nUtils.tr('TR_GUARDAR')}
                            name={FORM.FIELDS.SUBMIT}
                            disabled={this.handleIsSubmitDisabled()}
                            col={'col-md-4 col-md-offset-8'}
                            component={FormSubmit}
                        />
                    </Row>
                </form>
            </CardBody>
        );
    }
}

const mapStateToProps = (state) => {
    const fieldFileTouched = state.form[FORM.NAME] && state.form[FORM.NAME].values && state.form[FORM.NAME].values[FORM.FIELDS.FILE];
    const fieldFileErrorMessage = state.form[FORM.NAME] && state.form[FORM.NAME].syncErrors && state.form[FORM.NAME].syncErrors.file;

    return {
        formValues: ReduxFormUtils.selectFormValues(state, FORM.NAME),
        fileErrorMessage: fieldFileTouched ? fieldFileErrorMessage : '',
    };
};

export default connect(mapStateToProps)(
    reduxForm(
        {
            form: FORM.NAME,
            validate: ContractorFileFormValidator.validate,
            enableReinitialize: false,
        },
    )(ContractorFileFormCard),
);

ContractorFileFormCard.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
};

ContractorFileFormCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documentary-library/form/ContractorFileForm.js